import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { KeycloakGuard } from '@badgertechnologies/liblogin.js';
import { betaAccessGuardFn, roleGuardFn, UserDetailComponent, UsersComponent } from '@ng-cloud/badger-core';
import { OrganizationDnaComponent } from './badger-dna/organization-dna/organization-dna.component';
import { HomeComponent } from './home/home.component';
import { ThemeBuddyComponent } from './theme-buddy/theme-buddy.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    data: { roles: ['user'], reuse: true },
    canMatch: [roleGuardFn],
    canActivate: [KeycloakGuard]
  },
  {
    path: 'stores',
    loadChildren: () => import('./store/store.routes').then(m => m.STORE_ROUTES),
    data: { roles: ['user', 'client_portal', 'auditor', 'insight_auditor', 'external_insight_auditor', 'realogram_editor'] },
    canMatch: [roleGuardFn],
    canActivate: [KeycloakGuard]
  },
  {
    path: 'queued-base-scans',
    loadChildren: () => import('./base-scan-queue/base-scan-queue.routes').then(m => m.BASE_SCAN_QUEUE_ROUTES),
    data: { roles: ['admin', 'realogram_editor'] },
    canMatch: [roleGuardFn],
    canActivate: [KeycloakGuard]
  },
  {
    path: 'dna',
    component: OrganizationDnaComponent,
    data: { roles: ['Organization Executive', 'Regional Manager'] },
    canMatch: [roleGuardFn, betaAccessGuardFn],
    canActivate: [KeycloakGuard]
  },
  {
    path: 'themes',
    component: ThemeBuddyComponent,
    data: { roles: ['admin'] },
    canMatch: [roleGuardFn],
    canActivate: [KeycloakGuard]
  },
  {
    path: 'reports',
    loadChildren: () => import('./report/report.routes').then(m => m.REPORT_ROUTES),
    data: { roles: ['user', 'client_portal'] },
    canMatch: [roleGuardFn],
    canActivate: [KeycloakGuard]
  },
  {
    path: 'users/profile',
    component: UserDetailComponent,
    canActivate: [KeycloakGuard]
  },
  {
    path: 'users/:id',
    component: UserDetailComponent,
    data: { roles: ['organization_admin', 'Organization Executive', 'Regional Manager', 'Store Manager', 'IT'] },
    canActivate: [KeycloakGuard],
    canMatch: [roleGuardFn]
  },
  {
    path: 'users',
    component: UsersComponent,
    pathMatch: 'full',
    data: { roles: ['IT', 'Organization Executive', 'Regional Manager', 'Store Manager'] },
    canActivate: [KeycloakGuard],
    canMatch: [roleGuardFn]
  },
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'restricted', redirectTo: '/' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})]
})
export class AppRoutingModule {
}
